var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Tab as MuiTab } from "@mui/material";
import { COLORS } from "../../../constants";
import LoadingSkeleton from "../LoadingSkeleton";
import { tabStyles } from "./Tab.styles";
var Tab = function (_a) {
    var label = _a.label, loading = _a.loading, disabled = _a.disabled, standalone = _a.standalone, // if tab is not used within a "Tabs" group
    value = _a.value, sx = _a.sx, _b = _a.disableRipple, disableRipple = _b === void 0 ? true : _b, rest = __rest(_a, ["label", "loading", "disabled", "standalone", "value", "sx", "disableRipple"]);
    return (_jsx(MuiTab, __assign({ "data-testid": "button-tab-".concat(value), tabIndex: 0, value: value, disableRipple: disableRipple, sx: __assign(__assign(__assign({}, tabStyles), sx), { "&.MuiTab-root.Mui-selected": {
                borderBottom: standalone ? "2px solid ".concat(COLORS.SAY_COBALT) : "none",
            } }), disabled: disabled, label: !loading ? label : _jsx(LoadingSkeleton, {}) }, rest)));
};
export default Tab;
